import React, { useState, useEffect } from 'react';
import './Display.css';
import axiosInstance from "../interceptor/axiosInstance";

const DisplaySubsComponent = () => {
  const [settingsData, setSettingsData] = useState([]);
  const [chatSettings, setChatSettings] = useState([]);
  const [ticketSettings, setTicketSettings] = useState([]);

  // Fetch data on component mount
  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const response = await axiosInstance.get("/org/org-subscription");
        setSettingsData(response.data);
        setChatSettings(response.data.filter(setting => setting.type === 'chat'));
        setTicketSettings(response.data.filter(setting => setting.type === 'ticket'));
      } catch (error) {
        console.error("Error fetching subscriptions:", error);
      }
    };
    fetchSubscriptions();
  }, []);

  // Handle checkbox change and save settings
  const handleCheckboxChange = async (settingId, currentStatus, type) => {
    const updatedSettings = type === 'chat' ? [...chatSettings] : [...ticketSettings];
    const settingToUpdate = updatedSettings.find((setting) => setting.name === settingId); // Using 'name' instead of 'id' to update
    if (settingToUpdate) {
      settingToUpdate.enabled = !currentStatus;
      try {
        // Update settings on the server
        await axiosInstance.put(`/org/update-setting/${settingToUpdate.name}`, { // Use 'name' or 'id' depending on your backend
          enabled: !currentStatus,
        });
        // Update state with the new status
        type === 'chat' ? setChatSettings(updatedSettings) : setTicketSettings(updatedSettings);
      } catch (error) {
        console.error("Error updating subscription setting:", error);
      }
    }
  };

  return (
    <div className="settings-container">
      <h3 className="mb-0 heading-large">Subscription</h3>
      
      {/* Chat Settings */}
      <div className="settings-section mt-4">
       {/*  <h5 style={{ color: '#333', fontSize: '18px', marginBottom: '5px' }}>
          <b>Chat Settings</b>
        </h5> */}
        <div className='heading-small'>Chat Settings</div>

        <div className="settings-group">
          {chatSettings.map((setting, index) => (
            <div key={index} className="setting-item chat">
              <span className='label-text'>{setting.name}</span>
              <input className='form-check-input'
                type="checkbox"
                checked={setting.enabled}
                onChange={() => handleCheckboxChange(setting.name, setting.enabled, 'chat')}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Ticket Settings */}
      <div className="settings-section">
        {/* <h5 style={{ color: '#333', fontSize: '18px', marginBottom: '5px' }}>
          <b>Ticket Settings</b>
        </h5> */}
        <div className='heading-small'>Ticket Settings</div>
        <div className="settings-group">
          {ticketSettings.map((setting, index) => (
            <div key={index} className="setting-item ticket">
              <span className='label-text'>{setting.name}</span>
              <input
                type="checkbox" className='form-check-input'
                checked={setting.enabled}
                onChange={() => handleCheckboxChange(setting.name, setting.enabled, 'ticket')}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DisplaySubsComponent;
